export const ADMIN_ROUTES = {
  index: {
    path: 'admin/*',
    to: '/admin/interface',
  },
  interface: {
    path: 'admin/interface',
    to: '/interface',
  },
  organizations: {
    path: 'admin/*',
    to: '/admin/organizations',
  },

  map_overlay: {
    path: 'admin/*',
    to: '/admin/interface/map_overlay_site',
  },
}
